module.exports = __webpack_public_path__ + "img/NA.85c9b280.svg";